import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import Navbar from "./Navbar";
import GetLogo from "./GetLogo";
import { useLanguage } from "./Langs";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";

const Completed = (props) => {
  let [openHelp, setOpenHelp] = React.useState(false);

  let logo = GetLogo();

  const [lang, setLang] = useLanguage();

  return (
    <div style={{ backgroundColor: "#e0e0e0" }}>
      <Navbar
        lang={[lang, setLang]}
        disableToolBar
        openHelp={openHelp}
        color={logo.color}
        helpColor={logo.helpColor}
        banner={logo.banner}
        setOpenHelp={setOpenHelp}
      ></Navbar>

      <div
        style={{ marginTop: "100px", marginLeft: "15px", marginRight: "15px" }}
      >
        <div
          style={{
            backgroundColor: "white",
            width: "100%",
            maxWidth: "700px",
            height: "auto",
            margin: "0 auto",
            borderStyle: "solid 2px #000",
            border: "2px solid #0A213C",
            borderRadius: "25px",
            padding: "30px",
            boxShadow: "10px 10px 5px rgba(1, 1, 1, 0.5)",
            textAlign: "justify",
            borderColor: "transparent",
          }}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "50px",
              fontFamily: "Arial, Helvetica, sans-serif",
              fontWeight: "bold",
              lineHeight: "1.2em",
              marginBottom: "20px",
            }}
          >
            {lang.DocumentSigned}
          </p>
          <hr />

          <p
            style={{
              fontSize: "18px",
              fontFamily: "Arial, Helvetica, sans-serif",
              lineHeight: "1.7em",
            }}
          >
            {lang.Congratulations}
          </p>
          <div
            className="error-actions"
            style={{
              marginTop: "25px",
              textAlign: "center",
            }}
          >
            <a
              href={`/`}
              className="btn btn-primary btn-lg"
              style={{ marginRight: "10px", marginTop: "5px" }}
            >
              <span className="glyphicon glyphicon-home">
                <HomeIcon></HomeIcon>
              </span>
              {lang.TakeMeHome}{" "}
            </a>
            <a
              href="mailto:info@myshs.com"
              className="btn btn-default btn-lg"
              style={{
                border: "1px solid black",
                borderRadius: "5px",
                backgroundColor: "white",
                marginTop: "5px",
              }}
            >
              <span className="glyphicon glyphicon-envelope">
                <EmailIcon></EmailIcon>
              </span>{" "}
              {lang.ContactSupport}{" "}
            </a>
          </div>
        </div>

        <p style={{ textAlign: "center", margin: "50px", marginTop: "40px" }}>
          {lang.Experience}: <br></br>
          <a href="mailto:info@myshs.com">info@myshs.com</a>
        </p>
      </div>
    </div>
  );
};
export default Completed;
